import { classes } from "lib/actions/util";

export default function FormError(
  p: React.PropsWithChildren<{
    className?: string;
  }>,
) {
  if (!p.children) return null;

  return (
    <div className={classes("text-sm text-red-500", p.className)}>
      {p.children}
    </div>
  );
}
